import React, { useEffect, useMemo, useState } from 'react'
import { Typography, Button } from '@telavita-core/react-design-kit'

import { listPatients } from 'services/persons/listPatients'

import { Steps } from '../../'

import { Patient } from '../../types'

import * as S from './styles'

import { Select, ISingleValue, IOption } from 'components/ReactSelect'

interface FindPatientProps {
  onSelectPatient: (patient: Patient) => void
  onChangeStep: (step: Steps) => void
}

export function FindPatient({
  onChangeStep,
  onSelectPatient,
}: FindPatientProps): JSX.Element {
  const [loading, setLoading] = useState(true)
  const [patients, setPatients] = useState<Patient[]>([])
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [searchText, setSearchText] = useState('')
  
  const patientsOptions: IOption[] = useMemo(() => {
    return patients.map(patient => {
      return {
        value: patient.id,
        label: `${patient.fullName}\n${patient.email}`,
      }
    })
  }, [patients])

  function handleSelectPatient(patientOption: ISingleValue<IOption>) {
    if (!patientOption) {
      setButtonDisabled(true)
      return null
    }

    const selectedPatient = patients.find(patient => patient.id === patientOption.value)
    onSelectPatient(selectedPatient)
    setButtonDisabled(false)
  }

  function handleChangeNextStep() {
    onChangeStep(Steps.CHOOSE_RESERVATION)
  }

  useEffect(() => {
    async function getPatients() {
      const response = await listPatients()

      setPatients(response.patients)
      setLoading(false)
    }

    void getPatients()
  }, [])

  return (
    <S.FindPatientContainer>

      <Typography
        center
        variant='content2'
      >
        Selecione um paciente
      </Typography>
      
      <Select
        options={patientsOptions}
        isLoading={loading}
        onChange={handleSelectPatient}
        placeholder='Busque por nome ou e-mail'
        loadingMessage={() => 'Buscando pacientes...'}
        noOptionsMessage={() => 'Nenhum paciente encontrado'}
        onInputChange={setSearchText}
        inputValue={searchText}
      />
      
      <Button
        variant='contained'
        disabled={buttonDisabled}
        uppercase={false}
        onClick={handleChangeNextStep}
      >
        Prosseguir
      </Button>
    
    </S.FindPatientContainer>
  )
}